import PropTypes from 'prop-types';
import Select, { components as selectComponents } from "react-select";
import { sentenceCase } from '@repo/design-system/components/forms/utils';

import "./DropdownSelect.scss";

// Renders the non-selectable category header rows injected by
// buildAlphabeticalGroups (DropDown.jsx) when isAlphabeticallyGrouped is on.
const AlphabeticalGroupOption = (optionProps) => {
  if (optionProps.data?.isCategoryHeader) {
    return (
      <div className="dropdown-alpha-category-header">{optionProps.data.label}</div>
    );
  }
  return <selectComponents.Option {...optionProps} />;
};

// Keeps a category header visible while the input matches any of its child
// items, not just its own label, so grouped results don't lose their heading.
const alphabeticalFilterOption = (option, rawInput) => {
  const input = rawInput.trim().toLowerCase();
  if (!input) return true;

  const label = String(option.label).toLowerCase();
  if (option.data?.isCategoryHeader) {
    const childMatches = (option.data.childLabels || []).some((childLabel) =>
      String(childLabel).toLowerCase().includes(input)
    );
    return label.includes(input) || childMatches;
  }
  return label.includes(input);
};

function DropdownSelect(props) {

  return (
    <span className="d-inline-block custom-input">
      <Select className="custom-checkbox-select"
        value={props.value}
        onChange={props.handleDropdownChange}
        onBlur={props.handleDropdownBlur}
        options={props.optionsValue}
        isMulti={props.isMultiSelect}
        isClearable={props.isClearable !== undefined ? props.isClearable : true}
        placeholder={sentenceCase(props.placeholder)}
        isDisabled={props.isDropdownDisabled}
        isSearchable={props.isSearchable}
        isLoading={props.isLoading}
        menuPortalTarget={document.body}
        menuPosition="absolute"
        menuPlacement="auto"
        maxMenuHeight={props.maxMenuHeight}
        closeMenuOnSelect={props.isMultiSelect ? false : true}
        {...(props.isAlphabeticallyGrouped ? {
          components: { Option: AlphabeticalGroupOption },
          filterOption: alphabeticalFilterOption,
        } : {})}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }} />
    </span>
  );
}
DropdownSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object)
  ]),
  handleDropdownChange: PropTypes.func.isRequired,
  handleDropdownBlur: PropTypes.func,
  optionsValue: PropTypes.arrayOf(PropTypes.object).isRequired,
  isMultiSelect: PropTypes.bool,
  isAlphabeticallyGrouped: PropTypes.bool,
  placeholder: PropTypes.string,
  isDropdownDisabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isLoading: PropTypes.bool,
  maxMenuHeight: PropTypes.number
};

export default DropdownSelect;

